<template>
    <el-dialog
            class="detail-dialog-container"
            :visible.sync="dialogVisible"
            :before-close="cancel"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="`关联项目申报`"
            width="400px"
            center>
        <div class="dialog-container flex flex-direction">
            <el-form class="publish-form" :model="ruleForm" :rules="rules" ref="ruleForm" labelWidth="auto">
                <el-form-item prop="name"  label-width="0">
                    <el-select v-model="ruleForm.p_id" filterable placeholder="请选择项目">
                        <el-option
                            v-for="item in projects"
                            :key="item.id"
                            :label="item.p_name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="flex align-center justify-end" label-width="0">
                    <el-button  @click="cancel">取消</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>
</template>

<script>
import {relevancyApplyPro, getRelevancyProjectList} from "@/api";
    export default {
        name: "ChooseProjectApplyDialog",
        props: {
            dialogVisible: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                id:0,
                loading: false,
                ruleForm: {
                    p_id: '',
                },
                rules: {
                    p_id: [
                        {required: true, message: '请选择项目', trigger: 'blur'}
                    ],
                },
                projects:[]
            }
        },
        created() {
            this.init()
        },
        methods: {
            async init() {
                let _data = await getRelevancyProjectList()
                this.projects = _data.data
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.addItem();
                    }
                });
            },
            async addItem() {
                this.loading = true
                let p_name = this.projects.find(f=>{ return f.id === this.ruleForm.p_id}).p_name
                let _data = await relevancyApplyPro(this.ruleForm.p_id,p_name)
                this.loading = false
                if (_data.status === 200) {
                    this.clearContent()
                    this.$message.success(_data.msg)
                    this.$emit('watchState',true)
                }
            },
            clearContent(){
                this.$refs.ruleForm.resetFields()
            },
            cancel() {
                this.clearContent()
                this.$emit('watchState', false)
            },
        },
        watch: {
        }
    }
</script>

<style scoped lang="scss">

</style>